import React from "react";
import { ArrowUpRight, Compass } from "lucide-react";
import { buildPartnerUrl, openExternal } from "../../data/partnerLinks";

const PARTNERS = ["TourRadar", "BookRetreats", "GetYourGuide", "Intrepid Travel"];

export const PlannerFallback = ({ country, from, to, notes }) => (
  <div data-testid="ai-fallback" className="mt-6">
    <div className="flex items-start gap-2 rounded-xl bg-amber-50 p-4 text-sm text-amber-800">
      <Compass size={18} className="mt-0.5 flex-shrink-0" />
      <div>
        <p className="font-medium">No curated escape matched those dates</p>
        <p className="mt-1 opacity-90">
          {notes || "We couldn't build a full trip from our hand-picked escapes for that window. Search our trusted partners directly for live availability:"}
        </p>
      </div>
    </div>

    <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
      {PARTNERS.map((p) => (
        <button
          key={p}
          data-testid={`ai-fallback-${p.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          onClick={() => openExternal(buildPartnerUrl({ partner: p, title: country, country, from, to }))}
          className="group inline-flex items-center justify-between rounded-xl border border-brand-line p-4 text-sm font-medium text-brand-ink transition hover:border-brand-ink"
        >
          Search {p}
          <ArrowUpRight size={16} className="text-brand-inkSoft transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </button>
      ))}
    </div>
  </div>
);

export default PlannerFallback;
